import { Logo } from '@meteor/ui';
import styled from 'styled-components';

let Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
`;

let Inner = styled.div`
  text-align: center;
  width: 100%;
  max-width: 700px;
  padding: 20px;

  h1 {
    margin-top: 30px;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    color: #666;
    font-weight: 500;
  }

  footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 50px;

    a {
      color: black;
      font-size: 14px;
      transition: all 0.3s ease;
      font-weight: 500;
      padding: 7px 15px;
      border-radius: 10px;

      &:hover,
      &:focus {
        background: #ddd;
      }
    }
  }
`;

export let CheckoutHome = () => {
  return (
    <Wrapper>
      <Inner>
        <Logo />
        <h1>Metorial Checkout</h1>
        <p>
          Welcome to Metorial's Checkout website. This page is used for all billing or payment
          related activities. Please visit our{' '}
          <a href="https://next.metorial.com/legal/refund-and-payment-policy">
            Refund Policy and Payment
          </a>{' '}
          page for more information on how we handle payments and refunds. Visit our{' '}
          <a href="https://next.metorial.com/pricing">pricing page</a> to learn more about
          Metorial.
        </p>

        <footer>
          <div>
            <a href="https://next.metorial.com/legal/terms-of-service">Terms of Service</a>
          </div>
          <div>
            <a href="https://next.metorial.com/legal/privacy-policy">Privacy Policy</a>
          </div>
          <div>
            <a href="https://next.metorial.com/legal/refund-and-payment-policy">
              Payments and Refunds
            </a>
          </div>
          <div>
            <a href="https://next.metorial.com/legal/imprint">Imprint</a>
          </div>
        </footer>
      </Inner>
    </Wrapper>
  );
};
